import React, { useState, useEffect } from "react";
import { isAuthenticated } from "../../auth";
import { Redirect, Link } from "react-router-dom";
import Swal from "sweetalert2";

const DeleteHome = (props) => {
  const remove = (homeId, userId, token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/home/${homeId}/${userId}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then((data) => {
      Swal.fire("Deleted successfully");
    });
  };

  const Delete = () => {
    const token = isAuthenticated().token;
    const homeId = props.homeId;
    const userId = isAuthenticated().user._id;
    remove(homeId, userId, token);
  };

  const DeleteRoom = () => {
    let answer = window.confirm("Are you sure, you want to delete");
    if (answer) {
      Delete();
    }
  };

  return (
    <div>
      <div className="mb-2 ml-4 mt-2">
        <Link
          to="/list/rooms"
          className="btn btn-danger "
          style={{ borderRadius: "0" }}
          onClick={DeleteRoom}
        >
          Delete
        </Link>
      </div>
    </div>
  );
};

export default DeleteHome;
